export interface StorageInstance extends Storage {
  getItemAsync?: (key: string) => Promise<any>;
}

export class MyStorage {
  private _storage: StorageInstance;
  private _module: string;
  private _encode: boolean;
  constructor(storage: StorageInstance, module: string = '', encode = true) {
    this._storage = storage;
    this._module = module;
    this._encode = encode;
  }
  private _encodeData(data: any) {
    return this._encode ? JSON.stringify([data]) : data;
  }
  private _decodeData(data: any) {
    if (this._encode) {
      try {
        return JSON.parse(data)[0];
      } catch (_e) {
        return null;
      }
    } else {
      return data;
    }
  }
  private _assert(methodName: keyof StorageInstance) {
    const { _storage } = this;
    if (!_storage[methodName]) {
      throw new Error('Unrealized');
    }
  }
  getKey(key: string) {
    const { _module } = this;
    return `${_module && _module + ':'}${key}`;
  }
  setItem(key: string, value: any) {
    this._storage.setItem(this.getKey(key), this._encodeData(value));
  }
  getItem(key: string) {
    this._assert('getItem');
    return this._decodeData(this._storage.getItem!(this.getKey(key)));
  }
  async getItemAsync(key: string) {
    this._assert('getItemAsync');
    return this._decodeData(await this._storage.getItemAsync!(this.getKey(key)));
  }
  removeItem(key: string) {
    this._storage.removeItem(this.getKey(key));
  }
  clear() {
    this._storage.clear();
  }
  getModule(name: string) {
    return new MyStorage(this._storage, name, this._encode);
  }
  clearModule() {
    const {
      _module,
      _storage,
      _storage: { length, key },
    } = this;
    if (_module && length && Boolean(key)) {
      const prefix = this.getKey('');
      const reg = new RegExp(`^${prefix}`);
      const keys: string[] = [];
      for (let i = 0; i < length; i++) {
        const key = _storage.key(i)!;
        if (reg.test(key)) {
          keys.push(key);
        }
      }
      keys.forEach((key) => {
        _storage.removeItem(key);
      });
    }
  }
}

export const myLocalStorage = new MyStorage(localStorage);
export const mySessionStorage = new MyStorage(sessionStorage);
